import React from 'react';
import ReactMarkdown from 'react-markdown';
import LoadingStatus from '@/components/ui/LoadingStatus';
import { AIChatMessage } from '@/services/api';

interface MessageListProps {
  messages: AIChatMessage[];
  loading: boolean;
  messagesEndRef: React.RefObject<HTMLDivElement | null>;
}

const MessageList: React.FC<MessageListProps> = ({ messages, loading, messagesEndRef }) => {
  return (
    <div className="space-y-3">
      {messages.map((msg, idx) => (
        <div
          key={`${msg.role}-${idx}`}
          className={`flex ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}
        >
          <div
            className={`max-w-[85%] rounded-lg px-3 py-2 text-sm ${
              msg.role === 'user'
                ? 'bg-blue-600 text-white'
                : 'bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-gray-100'
            }`}
          >
            {msg.role === 'assistant' ? (
              <div className="prose prose-sm dark:prose-invert max-w-none [&>*:first-child]:mt-0 [&>*:last-child]:mb-0">
                <ReactMarkdown>{msg.content}</ReactMarkdown>
              </div>
            ) : (
              <p>{msg.content}</p>
            )}
          </div>
        </div>
      ))}

      {loading && (
        <div className="flex justify-start">
          <div className="rounded-lg bg-gray-100 px-3 py-2 dark:bg-gray-800">
            <LoadingStatus variant="inline" label="Analyzing response" />
          </div>
        </div>
      )}

      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessageList;
